import { useState, useEffect } from 'react'
import { HexColorPicker } from 'react-colorful'

export interface ColorPickerModalProps {
  isOpen: boolean
  initialColor: string
  label: string
  onSave: (color: string) => void
  onClose: () => void
}

const HEX_REGEX = /^#[0-9a-fA-F]{6}$/

export function ColorPickerModal({ isOpen, initialColor, label, onSave, onClose }: ColorPickerModalProps) {
  const [color, setColor] = useState(initialColor)
  const [hexInput, setHexInput] = useState(initialColor)

  useEffect(() => {
    if (isOpen) {
      setColor(initialColor)
      setHexInput(initialColor)
    }
  }, [isOpen, initialColor])

  if (!isOpen) return null

  const handleHexChange = (value: string) => {
    setHexInput(value)
    if (HEX_REGEX.test(value)) {
      setColor(value)
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={label}
    >
      <div
        className="bg-white dark:bg-gray-800 rounded-xl shadow-xl p-6 max-w-sm w-full mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100 mb-4">{label}</h3>

        <div className="flex flex-col items-center gap-4">
          <div className="flex items-center gap-4">
            <div
              className="w-16 h-16 rounded-full border-2 border-gray-200 dark:border-gray-600 shadow-inner shrink-0"
              style={{ backgroundColor: color }}
            />
            <HexColorPicker color={color} onChange={setColor} />
          </div>

          <div className="flex items-center gap-2 w-full">
            <label className="text-xs text-gray-500 dark:text-gray-400 shrink-0">Hex-Code:</label>
            <input
              type="text"
              value={hexInput}
              onChange={(e) => handleHexChange(e.target.value)}
              className="flex-1 px-2 py-1 text-sm border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 rounded font-mono"
              placeholder="#RRGGBB"
              maxLength={7}
            />
          </div>
        </div>

        <div className="flex justify-end gap-2 mt-6">
          <button
            onClick={onClose}
            className="px-3 py-1.5 text-sm bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded hover:bg-gray-300 dark:hover:bg-gray-600"
          >
            Abbrechen
          </button>
          <button
            onClick={() => onSave(HEX_REGEX.test(hexInput) ? hexInput : color)}
            className="px-3 py-1.5 text-sm bg-blue-500 text-white rounded hover:bg-blue-600 font-medium"
          >
            Speichern
          </button>
        </div>
      </div>
    </div>
  )
}
